import { Box, Grid, SelectChangeEvent } from "@mui/material"
import { KeyDriveSearchBar } from "../../../../../components/KeydriveComponents/SearchBars/KeyDriveSearchBar"
import { PersonOff } from "@mui/icons-material"
import { KeyDriveTable } from "../../../../../components/KeydriveComponents/Tables/KeyDriveTable"
import { EmptyContainer } from "../../../../../components/KeydriveComponents/EmptyContainer/EmptyContainer"
import { useTranslation } from "react-i18next"
import { ChangeEvent, Dispatch, SetStateAction, useEffect, useState } from "react"
import { UserRows } from "../NewWorkspace/components/UserRows"
import { WorkSpaceUpdate } from "../../../../../model/WorkSpaceModel"
import { useParams } from "react-router-dom"
import { AddPermissionUser, GetOneWorkSpace } from "../../../../../services/WorkSpaceServices"
import { GetOrganizationUserName } from "../../../../../services/OrganizationServices"
import { ObjectPermissionUser } from "../../../../../model/PermissionModel"
import { UserPermission } from "../../../../../model/UserModel"
interface IWorkspaceUserConfig {
    setAllUsersEx?: Dispatch<SetStateAction<string[]>>
    viewOnly?: boolean,
    hasPrivilegesColumn?: boolean
}
export const WorkspaceUserConfig: React.FC<IWorkspaceUserConfig> = ({setAllUsersEx, viewOnly = false, hasPrivilegesColumn = false}) => {
    const { t } = useTranslation();
    const {idWorkspace } = useParams();
    const [selectUserSearch, setselectUserSearch] = useState<string>("");
    const [allUsers, setAllUsers] = useState<string[]>([]);
    const tableHeaders: string[] = [
    ...(hasPrivilegesColumn ? [t("AdminConsole.Privileges")] : []),
    t("AdminConsole.Name"),
    "E-mail"
    ];
    const [userObjects, setUserObjects] = useState<UserPermission[]>([]);

    function getWorkspace(): void {
        if (idWorkspace != undefined) {
            GetOneWorkSpace(idWorkspace)
                .then(data => {
                    if (data) {
                        let users: string[] = [];
                        if (data.users != undefined) {
                            users = data.users?.flatMap(user => user.userId) ?? [];
                            setUserObjects(data.users!);
                        }
                        setAllUsers(users!);

                        if (setAllUsersEx) {
                            setAllUsersEx(users!);
                        }
                    } else {
                        console.log("Error")
                    }
                })
                .catch()
                .finally();
        }
    }

    function handleUserSeach(event: ChangeEvent<HTMLInputElement>): void {
        setselectUserSearch(event.target.value);
    }

    useEffect(() => {
        getWorkspace();
    }, [idWorkspace]);

    return (
        <>
            <Grid container spacing={2} display="flex" alignItems="flex-end" mb="20px" >
                <Grid item xs={12}>
                    <KeyDriveSearchBar
                        onChange={handleUserSeach}
                        value={selectUserSearch}
                    />
                </Grid>
            </Grid>
            {
                allUsers.length > 0 ? (
                    <KeyDriveTable
                        viewOnly={viewOnly}
                        headers={tableHeaders}
                        body={
                            allUsers
                                .map(user => (
                                    <UserRows
                                        userId={user}
                                        setAllUsers={viewOnly ? undefined : setAllUsers}
                                        allUsers={allUsers}
                                        filterName={selectUserSearch}
                                        valuePrivilege={userObjects.filter(obj => obj.userId == user)![0]?.permissionType}
                                        viewOnly={viewOnly}
                                        hasPrivilegesColumn={hasPrivilegesColumn}
                                    />
                                ))
                        }
                        needFooter={false}
                    />
                ) : (
                    <div style={{height: "calc(100vh - 583px)"}}>

                        <EmptyContainer
                            content={t("AdminConsole.TheWorkspaceDoesNotHaveAnyLinkedUsersYet")}
                            icon={
                                <Box
                                    width="40px"
                                    height="40px"
                                    borderRadius="50%"
                                    bgcolor="#D3E0E8"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    mb="12px"
                                >
                                    <PersonOff
                                        sx={{
                                            color: "#22638D"
                                        }}
                                    />
                                </Box>
                            }
                            title={t("AdminConsole.NoUsersInWorkspace")}
                        />
                    </div>
                )
            }
        </>
    )
}